import { ContasReceberModel } from './../models/contas-receber.model';
import { Component, OnInit } from '@angular/core';
import jsPDF from 'jspdf';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { ClienteModel } from '../app.login.model';
import { ChamadaModel } from '../models/chamada.model';
import { DashboardService } from './dashboard.service';
import { ClienteElevadorModel } from '../models/cliente.elevadores.model';
import { CodigoAtendimentoModel } from '../models/codigo-atendimento.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  //VARIAVEIS
  data: ChamadaModel
  currentUser: ClienteModel = JSON.parse(localStorage.getItem('usuarioLogado'));

  lista: ChamadaModel[];
  selecionados: ChamadaModel[];
  loading: boolean = true;

  listaElevadores: ClienteElevadorModel[]
  visitas: CodigoAtendimentoModel[];

  cols: any[];

  listaVisita: any;

  filtros: ChamadaModel = new ChamadaModel();

  //NOTA FISCAL
  dataNotaFiscal: ContasReceberModel
  listaNotaFiscal: ContasReceberModel[];
  selecionadosNotaFiscal: ContasReceberModel[];
  loadingNotaFiscal: boolean = true;
  //

  //BOLETO
  dataBoletoBancario: ContasReceberModel
  listaBoletoBancario: ContasReceberModel[];
  selecionadosBoletoBancario: ContasReceberModel[];
  loadingNotaBoletoBancario: boolean = true;
  //

  dataInicial: Date;
  dataFinal: Date;
  
  //

   //FILTROS//
   filtro_visita: string
   filtro_elevador: string
   //
  constructor(
    private service: DashboardService,
    private messageService: MessageService,
    private config: PrimeNGConfig) {

    this.dataInicial = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    this.dataFinal = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1);

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    this.dataFinal.setDate(this.dataFinal.getDate() - 1);
    // console.log(this.currentUser);
    this.data = {}
    this.dataNotaFiscal = {}
    this.dataBoletoBancario = {}

    // this.listaVisita = [{ nome: '01 - CHAMADO' }, { nome: '03 - MANUTENÇÃO PREVENTIVA' }, { nome: '04 - MANUTENÇÃO CORRETIVA (SERVIÇOS)' },
    // { nome: '09 - MANUTENÇÃO CORRETIVA (MODERNIZAÇÃO)' }, { nome: '10 - CORRETIVA PROGRAMADA' }, { nome: '12 - VISTORIA SUPERVISOR' }]

    //#region LISTA ELEVADORES
    service.ListarElevador(this.currentUser.cod_cliente).subscribe(data => {
      if (data.success) {
        this.listaElevadores = data.data;
      } else {
        this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
      }
    },
      err => console.error(err)
    );
    //#endregion

    //#region LISTA VISITAS
    service.BuscarCodigoAtendimento().subscribe(data => {
    if (data.success) {
        this.visitas = data.data.filter(x => x.tipo == 'Visita');
      }
      else {
          this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
      }
      },
      err => {
          this.messageService.add({ severity: 'error', summary: 'Informação', detail: err });
      }
    );
    //#endregion
  }

  ngOnInit(): void {
    this.Listar();
    this.ListarNotaFiscal();
    this.ListarBoletoBancario();

    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'price', header: 'Price' },
      { field: 'category', header: 'Category' },
      { field: 'rating', header: 'Reviews' },
      { field: 'inventoryStatus', header: 'Status' }
    ];
  }

  Listar() {
    this.loading = true;
    try {

      this.currentUser.filtro_data_inicial = this.dataInicial;
      this.currentUser.filtro_data_final = this.dataFinal;
      this.currentUser.filtro_visita = this.filtro_visita;
      this.currentUser.filtro_elevador = this.filtro_elevador;
      // console.log(this.currentUser);
      this.service.Buscar(this.currentUser)
        .subscribe(data => {
          if (data.success) {
            this.lista = data.data;
            console.log(data)
            this.loading = false;
          } else {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
            this.loading = false;

          }
        },
          err => console.error(err)
        );

    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
    }
  }

  ListaElevador(dados: ChamadaModel) {
    try {

    this.service.ListarElevador(dados.cod_cliente)
        .subscribe(data => {
        if (data.success) {
            this.listaElevadores = data.data;
            this.data.elevador = dados.elevador;
        } else {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
        }
        },
        err => console.error(err)
        );

    } catch (error) {
    this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
    }
}

  pesquisar() {
    this.Listar();
    this.ListarNotaFiscal();
    this.ListarBoletoBancario();
  }

  ListarNotaFiscal() {
    this.loadingNotaFiscal = true;
    try {

      this.currentUser.filtro_data_inicial = this.dataInicial;
      this.currentUser.filtro_data_final = this.dataFinal;
      // console.log(this.currentUser);
      this.service.BuscarNotaFiscal(this.currentUser)
        .subscribe(data => {
          if (data.success) {
            this.listaNotaFiscal = data.data;
            this.loadingNotaFiscal = false;
          } else {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
            this.loadingNotaFiscal = false;

          }
        },
          err => console.error(err)
        );

    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
    }
  }

  imprimirNF(dados:ContasReceberModel) {
    window.open(dados.nfse_url, "_blank");
  }

//   imprimirICMS(dados:ContasReceberModel) {
//     this.loadingNotaFiscal = true;
//     try {

//     this.service.ImprimirICMS(dados)
//         .subscribe(data => {
//           if (data.success) {
//             window.open(data.data.nfse_url, "_blank");
//             this.loading = false;
//           } else {
//             this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
//             this.loading = false;

//           }
//         },
//           err => console.error(err)
//         );

//     } catch (error) {
//       this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
//     }
//   }

  ListarBoletoBancario() {
    this.loadingNotaBoletoBancario = true;
    try {

      this.currentUser.filtro_data_inicial = this.dataInicial;
      this.currentUser.filtro_data_final = this.dataFinal;
      // console.log(this.currentUser);
      this.service.BuscarBoletoBancario(this.currentUser)
        .subscribe(data => {
          if (data.success) {
            this.listaBoletoBancario = data.data;
            this.loadingNotaBoletoBancario = false;
          } else {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
            this.loadingNotaBoletoBancario = false;

          }
        },
          err => console.error(err)
        );

    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
    }
  }

  imprimirBoleto(dados:ContasReceberModel) {
    this.loadingNotaBoletoBancario = true;
    try {

    this.service.imprimirBoleto(dados)
        .subscribe(data => {
          if (data.success) {
            window.open(data.data.nfse_url, "_blank");
            this.loadingNotaBoletoBancario = false;
          } else {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
            this.loadingNotaBoletoBancario = false;

          }
        },
          err => console.error(err)
        );

    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
    }
  }

//   verificarVencimento(parcela: ContasReceberModel) {
//     let hoje = new Date();
//     let vencimento = new Date(parcela.vencimento)

//     if (vencimento > hoje) {
//       return 'transparent';
//     } else if (vencimento.getDate() == hoje.getDate()) {
//       return '#b6ff97';
//     }
//     return '#ffbaba';
//   }

      RelatorioSintetico: boolean = false
      
      gerarRelatorioSintetico() {
        this.RelatorioSintetico = true;
        try {

          this.loading = true;
          this.RelatorioSintetico = true;

          let chamada: ChamadaModel = {
            ...this.data, // Spread operator to copy all properties from this.data
            cliente: this.currentUser.nome_fantasia,
            cod_cliente: this.currentUser.cod_cliente,
            data_inicial: this.currentUser.filtro_data_inicial,
            data_final: this.currentUser.filtro_data_final,
            visita: this.currentUser.filtro_visita,
            elevador: this.currentUser.filtro_elevador,
            coligada: "ELEVATOR",
            rpt: 'rptChamadas',
            resolvido: "SIM"

        };
        
        this.data = chamada;
        

          this.data = chamada;
          console.log(chamada)
          let resposta = this.service.GerarRelatorio(this.data);
          resposta.subscribe(data => {
    
            console.log(this.data)
            if (data != null && data.success) {
              this.loading = false;
              if (typeof data.data === 'string' && data.data) {
                window.open(data.data, "_blank");
              } else {
                // Caso data.data não seja uma URL válida, trate aqui
                this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'URL do relatório não disponível ou inválida.' });
              }
            } else {
              this.loading = false;
              this.RelatorioSintetico = false;
              this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
            }
          });
        } catch (error) {
          this.loading = false;
          this.RelatorioSintetico = false;
          this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível gerar relatório!" + error });
        }
      }

    //   RelatorioPorHora: boolean = false
    //   gerarRelatorioPorTempo() {
    //     this.RelatorioPorHora = true;
    //     try {

    //       let chamada: ChamadaModel = {
    //         filtro_data_inicial: this.dataInicial,
    //         filtro_data_final: this.dataFinal,
    //         cod_cliente: this.currentUser.cod_cliente,
    //         rpt: 'rptChamadaPorTempo'
    //       }
    //       this.service.GerarRelatorio(chamada)
    //         .subscribe(data => {
    //           if (data.success) {
    //             console.log(data);
    //             window.open(data.data.link, "_blank");
    //             this.RelatorioPorHora = false;
    //           } else {
    //             this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
    //             this.RelatorioPorHora = false;

    //           }
    //         },
    //           err => {
    //             this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível gerar relatório! erro:" + err }),
    //               this.RelatorioPorHora = false
    //           }
    //         );

    //     } catch (error) {
    //       this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível gerar relatório! erro:" + error });
    //     }
    //   }

    //   RelatorioAnalitico: boolean = false
    //   gerarRelatorioAnalitico() {
    //     this.RelatorioAnalitico = true;
    //     try {

    //       let chamada: ChamadaModel = {
    //         filtro_data_inicial: this.dataInicial,
    //         filtro_data_final: this.dataFinal,
    //         cod_cliente: this.currentUser.cod_cliente,
    //         rpt: 'rptRelatorioAnaliticoAtendimento'
    //       }
    //       this.service.GerarRelatorio(chamada)
    //         .subscribe(data => {
    //           if (data.success) {
    //             console.log(data);
    //             window.open(data.data.link, "_blank");
    //             this.RelatorioAnalitico = false;
    //           } else {
    //             this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.message });
    //             this.RelatorioAnalitico = false;

    //           }
    //         },
    //           err => {
    //             this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível gerar relatório! erro:" + err }),
    //               this.RelatorioAnalitico = false
    //           }
    //         );

    //     } catch (error) {
    //       this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível gerar relatório! erro:" + error });
    //     }
    //   }


}

